export const locale = {
    id: 'es-ES'
}
